<app-header></app-header>
<app-sidebar></app-sidebar>

<div class="content-wrapper" style="min-height: 307px">

    <div class="row">
        <div class="col-12">
          <div class="card card-primary card-outline card-tabs">
            <p class="card-title pl-2 mt-2 headText2"><i class="fas fa-users"></i> ระบบบริหารงานพนักงานฝ่ายจัดหาวัตถุดิบ</p>
            <div class="card-header pt-1 border-bottom-0">
              <ul class="nav nav-tabs headText" id="custom-tabs-three-tab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="custom-tabs-three-dashboard-tab" data-toggle="pill" href="#custom-tabs-three-dashboard" role="tab" aria-controls="custom-tabs-three-dashboard" aria-selected="false"> <i class="fas fa-chart-area"></i> dashboard</a>
                  </li>
                <li class="nav-item">
                  <a class="nav-link" id="custom-tabs-three-home-tab" data-toggle="pill" href="#custom-tabs-three-home" role="tab" aria-controls="custom-tabs-three-home" aria-selected="true"><i class="fas fa-users"></i> พนักงาน</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="custom-tabs-three-position-tab" data-toggle="pill" href="#custom-tabs-three-position" role="tab" aria-controls="custom-tabs-three-position" aria-selected="false"><i class="far fa-address-card"></i> ตำแหน่ง</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="custom-tabs-three-messages-tab" data-toggle="pill" href="#custom-tabs-three-messages" role="tab" aria-controls="custom-tabs-three-messages" aria-selected="false"><i class="fas fa-home"></i>  แผนก</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="custom-tabs-three-faction-tab" data-toggle="pill" href="#custom-tabs-three-faction" role="tab" aria-controls="custom-tabs-three-faction" aria-selected="false"><i class="fas fa-city"></i>  ฝ่าย</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="custom-tabs-three-settings-tab" data-toggle="pill" href="#custom-tabs-three-settings" role="tab" aria-controls="custom-tabs-three-settings" aria-selected="false"> <i class="fas fa-address-card"></i> การอบรม</a>
                </li>
              </ul>
            </div>
            <div class="card-body">
              <div class="tab-content" id="custom-tabs-three-tabContent">
                <div class="tab-pane fade show active" id="custom-tabs-three-dashboard" role="tabpanel" aria-labelledby="custom-tabs-three-dashboard-tab">
                  <div class="row">
                    <!-- Dashboard ข้อมูลพนักงาน  -->
                    <app-emp-dashboard></app-emp-dashboard>
                  </div>
                </div>
                <div class="tab-pane fade show" id="custom-tabs-three-home" role="tabpanel" aria-labelledby="custom-tabs-three-home-tab">
                  <!-- ข้อมูลพนักงาน เพิ่ม แก้ไข  -->
                  <app-emp-add></app-emp-add>
                  <!-- List ข้อมูลพนักงาน -->
                  <!-- <app-emp-list></app-emp-list> -->
                </div>
                <div class="tab-pane fade" id="custom-tabs-three-position" role="tabpanel" aria-labelledby="custom-tabs-three-position-tab">
                  <app-emp-position></app-emp-position>
                </div>
                <div class="tab-pane fade" id="custom-tabs-three-messages" role="tabpanel" aria-labelledby="custom-tabs-three-messages-tab">
                    <app-emp-dep></app-emp-dep>
                </div>
                <div class="tab-pane fade" id="custom-tabs-three-faction" role="tabpanel" aria-labelledby="custom-tabs-three-faction-tab">
                  <app-emp-faction></app-emp-faction>
              </div>
                <div class="tab-pane fade" id="custom-tabs-three-settings" role="tabpanel" aria-labelledby="custom-tabs-three-settings-tab">
                    อยู่ระหว่างพัฒนา...                
                </div>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>
    </div>

</div>

<app-footer></app-footer>
